import Context from '@/ViewModels/Context';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import GenericObject from '@/Model/GenericObject';
import ViewFactory from '@/Factories/ViewFactory';
import { IGenericObjectConstructorParameter } from '#/CoreFrameInterfaces';

export default class ViewExtensionContext extends Context {

    private static currentViewFactory: KnockoutObservable<ViewFactory> = ko.observable(null);

    public genericObject: GenericObject;

    constructor(private params) {
        super(params);
        this.genericObject = this.createGenericObject();
    }


    /*
     * Generiert ein neues GenericObject für den Kontext
     * @returns {GenericObject} - Ein neues GenericObject auf Basis der aktuellen ViewFactory
     */
    private createGenericObject(): GenericObject {
        let currentViewFactory = ViewExtensionContext.currentViewFactory();
        let subject = this.parseSubject(currentViewFactory);

        return new GenericObject(subject);
    }

    /*
     * Parsed ein Subject anhand einer ViewFactory
     * @returns {object} - Ein für die Erzeugung eines GenericObject geeignetes Object
     */
    private parseSubject(viewFactory: ViewFactory): IGenericObjectConstructorParameter {
        let result = { values: {} };

        if (viewFactory == null) {
            return result;
        }

        for (let i = 0; i < this.params.length; i++) {
            let prop = this.params[i];

            if (prop in viewFactory) {
                result.values[prop] = viewFactory[prop];
            }
        }

        return result;
    }
}

ComponentManager.setViewModel('ViewExtensionContext', ViewExtensionContext, 'RADPresentation.HTMLClient.DefaultViewExtensions');